import {defineAsyncComponent, markRaw} from "vue";
import {CheckoutSuccessProps} from "../../Components/CheckoutSuccess.vue";
import LoadingState from "../../Widgets/ModalWidget/Views/components/LoadingState.vue";
import ROUTE_NAMES from "../../Widgets/ModalWidget/Routes/constants";
import {WidgetLocationRaw} from "./contracts";
export class CheckoutSuccessRoute implements WidgetLocationRaw {
    // Same name as CheckoutRoute: navigation, visibility and analytics treat both as the checkout.
    public name = ROUTE_NAMES.CHECKOUT;
    public readonly layout: false = false;
    public readonly switchLanguage = false;
    public readonly title: false = false;
    public component = markRaw(defineAsyncComponent({
        loader: () => import( '../../Components/CheckoutSuccess.vue'),
        loadingComponent : LoadingState
    }));
    public props: CheckoutSuccessProps;
    constructor(props: CheckoutSuccessProps) {
        this.props = props;
    }
}
